import React from 'react'
import PropTypes from 'prop-types'
import inquriesBackground from '../../assets/inquires.jpg'

import styles from './ContactSection.module.scss'

const ContactSection = ({ showContactForm }) => (
    <div className={styles.contactSection} style={{ backgroundImage: `url(${inquriesBackground})` }}>
        <h3 className={styles.txt}>contact us about this exhibition</h3>
        <div className={`${styles.center} row`}>
            <div className={styles.btnSize}>
                <button type="button" className="btn" onClick={showContactForm}>Learn more</button>
            </div>
        </div>
    </div>
)

ContactSection.propTypes = {
    showContactForm: PropTypes.func.isRequired,
}

export default ContactSection
